import { render, staticRenderFns } from "./CenterServer.vue?vue&type=template&id=000e10be&scoped=true"
import script from "./CenterServer.vue?vue&type=script&lang=js"
export * from "./CenterServer.vue?vue&type=script&lang=js"
import style0 from "./CenterServer.vue?vue&type=style&index=0&id=000e10be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000e10be",
  null
  
)

export default component.exports